module.exports = __webpack_public_path__ + "static/media/green_nebula_skybox_RT.68298823.png";